import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AiPeerReviewSection"] */ "/vercel/path0/components/work/components/AiPeerReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundersSection"] */ "/vercel/path0/components/work/components/FundersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundingOpportunitySection"] */ "/vercel/path0/components/work/components/FundingOpportunitySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundraiseSection"] */ "/vercel/path0/components/work/components/FundraiseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NonprofitSection"] */ "/vercel/path0/components/work/components/NonprofitSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PeerReviewsSection"] */ "/vercel/path0/components/work/components/PeerReviewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicsSection"] */ "/vercel/path0/components/work/components/TopicsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeader"] */ "/vercel/path0/components/work/WorkHeader/WorkHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeaderGrant"] */ "/vercel/path0/components/work/WorkHeader/WorkHeaderGrant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeaderProposal"] */ "/vercel/path0/components/work/WorkHeader/WorkHeaderProposal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkTabProvider","useWorkTab"] */ "/vercel/path0/components/work/WorkHeader/WorkTabContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
